import { render, staticRenderFns } from "./Wounds.vue?vue&type=template&id=ae533316&"
import script from "./Wounds.vue?vue&type=script&lang=js&"
export * from "./Wounds.vue?vue&type=script&lang=js&"
import style0 from "./Wounds.vue?vue&type=style&index=0&id=ae533316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports